import script from "./drawer.vue?vue&type=script&setup=true&lang=js"
export * from "./drawer.vue?vue&type=script&setup=true&lang=js"

import "./drawer.vue?vue&type=style&index=0&id=0209379a&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0209379a"]])

export default __exports__